<template>
  <div class="modal-mask" @mousedown.self.stop="closeModal">
    <div class="modal-inner">
      <div class="modal-wrap" @click.stop="closeItemsPopups">
        <div class="modal-wrap__close-row">
          <div class="modal-wrap__close" @click.stop="closeModal">
            <svg class="close-icon" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L12 12" stroke="currentColor" stroke-width="2"/>
              <path d="M1 12L12 1" stroke="currentColor" stroke-width="2"/>
            </svg>
          </div>
        </div>
        <div class="modal-content">
          <section class="structure">
            <!-- главная строка -->
            <div class="structure__row">
              <div class="structure__item structure__item_main-parent" :class="department.children.length === 0 ? 'no-children' : ''">
                  <DepartmentCard :department="department"
                                  :is-controls-active="department.isControlsActive"
                                  :is-staff-list-active="department.isStaffListActive"
                                  :allow-controls="allowControls"
                                  :allowed-control-items="allowedControlItems"
                                  @show-detail-modal="showDetailDepartmentModal"
                                  @add-child-department="creatChildDepartment"
                                  @update-department="updateDepartment"
                                  @remove-department="removeDepartment(department.id)"
                                  @toggle-controls="toggleItemControls(department.id)"
                                  @toggle-staff-list="toggleItemStaffList(department.id)"
                  />
              </div>
            </div>
            <!-- /главная строка -->

            <!-- строка дочерних отделов -->
            <transition name="fade">
              <div class="structure__row" v-if="department.children !== []">
                <div v-for="(item, i) in department.children"
                     :key="i"
                     class="structure__item structure__item_main-child"
                     :style="`z-index: ${99 - i};`">
                  <DepartmentCard :department="item"
                                  :is-controls-active="item.isControlsActive"
                                  :is-staff-list-active="item.isStaffListActive"
                                  :allow-controls="allowControls"
                                  :allowed-control-items="allowedControlItems"
                                  @show-detail-modal="showDetailDepartmentModal"
                                  @add-child-department="creatChildDepartment"
                                  @update-department="updateDepartment"
                                  @remove-department="removeDepartment(item.id)"
                                  @toggle-controls="toggleItemControls(item.id)"
                                  @toggle-staff-list="toggleItemStaffList(item.id)"
                                  @show-department-modal="showModalNextLevel"
                  />
                </div>
              </div>
            </transition>
            <!-- /строка дочерних отделов -->
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import DepartmentCard from '../user/DepartmentCard'

export default {
  name: 'structure-modal',
  components: { DepartmentCard },
  props: {
    department: {
      type: Object,
      default: () => ({})
    },
    allowControls: {
      type: Boolean,
      default: false
    },
    allowedControlItems: {
      type: Object,
      default: () => ({
        add: true, update: true, remove: false
      })
    }
  },
  methods: {
    closeModal () {
      this.$emit('close-modal')
    },
    showModalNextLevel (department) {
      this.$store.dispatch('showDepartmentTreeModal', department)
    },
    showDetailDepartmentModal (department) {
      this.$emit('show-department-detail', department)
    },
    creatChildDepartment (parent) {
      this.$store.dispatch('setNewDepartmentParent', parent)
      this.$router.push({ path: '/departments/create' })
      this.closeModal()
    },
    updateDepartment (department) {
      this.$emit('update-department', department)
    },
    removeDepartment (departmentId) {
      this.$emit('remove-department', departmentId)
    },
    toggleItemControls (departmentId) {
      this.$emit('toggle-controls', departmentId)
    },
    toggleItemStaffList (departmentId) {
      this.$emit('toggle-staff-list', departmentId)
    },
    closeItemsPopups () {
      this.$emit('close-popups')
    }
  },
  updated () {
    if (this.department.children.length === 0) {
      this.closeModal()
    }
  }
}

</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.modal-mask {
  background: rgba(0, 0, 0, 0);
  justify-content: flex-start;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: $color_third;
  }

  &::-webkit-scrollbar-thumb {
    background-color: $color_second;
  }
}

.modal-inner {
  margin-left: auto;
  margin-right: auto;
}

.modal-wrap {
  padding: 30px;
  padding-bottom: 40px;
  background: rgba(196, 196, 196, .85);
  border: 1px solid $border_color;
  border-radius: 3px;

  &__close-row {
    display: flex;
    justify-content: flex-end;
  }

  &__close {
    @include size(24px);
    color: $font_color_second;
    cursor: pointer;
    transition: .3s;

    &:hover {
      color: $font_color_main;
    }
  }
}

.structure {
  &__row {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
  }

  &__item {
    position: relative;

    &_main-parent {
      z-index: 999;
      margin-bottom: 50px;

      &.no-children {
        &:after {
          display: none;
        }
      }

      &:after {
        content: '';
        position: absolute;
        top: auto;
        left: 0;
        right: 0;
        margin: 0 auto;
        display: block;
        width: 2px;
        height: 30px;
        background-color: $color_second-light;
      }
    }

    &_main-child {
      margin-right: 10px;

      &:before {
        content: '';
        position: absolute;
        top: -20px;
        left: 0;
        right: 0;
        margin: 0 auto;
        display: block;
        width: 2px;
        height: 20px;
        background-color: $color_second-light;
      }

      &:not(:first-child) {
        &:before {
          content: '';
          position: absolute;
          top: -20px;
          left: 0;
          right: 0;
          margin: 0 auto;
          display: block;
          width: 2px;
          height: 20px;
          background-color: $color_second-light;
        }

        &:after {
          content: '';
          position: absolute;
          top: -20px;
          left: -153px;
          display: block;
          width: 296px;
          height: 2px;
          background-color: $color_second-light;
        }
      }
    }
  }
}

.department-card {
  border: 1px solid $border_color;
}
</style>
